
import Vue from "vue";
import LINK from "@/utils/link";
import { convertToPersian, separateDigits } from "@/utils/string";
import store from "@/store";

export default Vue.extend({
  name: "LandingProductCard",
  data() {
    return {
      LINK: LINK,
      imgPrefix: "images/landing/",
    };
  },
  props: {
    // data
    id: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      required: true,
      default: "",
    },
    amount: {
      type: Number,
      required: true,
      default: NaN,
    },
    img: {
      type: String,
      default: "",
    },
    special_sell: {
      type: Number,
      default: null,
    },
    // setting
    externalClass: {
      type: String,
      required: false,
      default: "",
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    separateDigits,
    convertToPersian,

    deleteProduct(id: string) {
      store.dispatch("admin/deleteLandingProduct", id);
    },
  },
});
